import { render, staticRenderFns } from "./Asset-Content.vue?vue&type=template&id=5534dc0c&"
import script from "./Asset-Content.vue?vue&type=script&lang=ts&"
export * from "./Asset-Content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports